import React, { FC, Fragment } from "react"
import { FooterLinkProps } from "../Footer.types"

const FooterLinks: FC<FooterLinkProps> = ({ links }) => {
    return (
        <div className="zb-footer-links">
            {links.map((l, i) => {
                const id = l.id ?? `footer-link-${i}`
                return (
                    <Fragment key={i}>
                        <a
                            key={i}
                            id={id}
                            href={l.link}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {l.text}
                        </a>

                        {i !== links.length - 1 && (
                            <span id={`${id}-separator`}> | </span>
                        )}
                    </Fragment>
                )
            })}
        </div>
    )
}

export default FooterLinks
